"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SpeakerVolumeUpOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="M16.424 7.094A1 1 0 0 1 17 8v16a1 1 0 0 1-1.64.768L9.638 20H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3.638l5.722-4.768a1 1 0 0 1 1.064-.138zM15 10.135l-4.36 3.633A1 1 0 0 1 10 14H7v4h3a1 1 0 0 1 .64.232L15 21.865v-11.73zm8.055 1.459C21.917 10.494 20.653 10 20 10a1 1 0 1 1 0-2c1.347 0 3.083.84 4.445 2.156C25.845 11.51 27 13.506 27 16c0 2.645-1.142 4.65-2.568 5.981C23.044 23.276 21.312 24 20 24a1 1 0 1 1 0-2c.689 0 1.956-.443 3.068-1.481C24.142 19.516 25 18.02 25 16c0-1.84-.846-3.344-1.945-4.406z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M19.76 13.971h-.003a1 1 0 1 1 .485-1.941c.634.158 1.306.695 1.794 1.314C22.552 14 23 14.92 23 16s-.448 2-.964 2.656c-.488.62-1.16 1.156-1.794 1.314a1 1 0 1 1-.485-1.94l.002-.001c.016-.007.099-.041.235-.143.147-.11.314-.269.47-.467.317-.403.536-.9.536-1.419 0-.52-.219-1.016-.536-1.419a2.605 2.605 0 0 0-.47-.467 1.099 1.099 0 0 0-.235-.143z" clip-rule="evenodd"></path>';
var SpeakerVolumeUpOutlineSVG = function SpeakerVolumeUpOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.SpeakerVolumeUpOutlineSVG = SpeakerVolumeUpOutlineSVG;
SpeakerVolumeUpOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SpeakerVolumeUpOutlineSVG);
exports.default = _default;